import { StatsigClient, type StatsigUser } from "@statsig/react-bindings";
import { createStore } from "zustand";
import { combine } from "zustand/middleware";

import { createStoreGetters } from "~/stores/root";

import { FeatureFlagName } from "../feature-flags/defs";

// token for captions-app statsig project
const SDK_KEY = "client-OycZCi7Fla9OAJ28MZJBRACMF0zYu0szO3olgtzyNQR";

const createStatsigUser = (userID: string | undefined, orgID: string | undefined): StatsigUser => {
  return {
    userID,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    custom: {
      platform: "mirage-studio",
      orgID,
    },
  };
};

// this is exported so that we can provide it to Statsig's own provider
// please do not use this directly, since it's initialization is handled by the store
export const statsigClient = new StatsigClient(SDK_KEY, {});

interface StatsigStoreState {
  instance: StatsigClient;
}

export function createStatsigStore() {
  return createStore(
    combine({ instance: statsigClient } as StatsigStoreState, (_set, get) => {
      return {
        async init() {
          await statsigClient.initializeAsync();
        },
        async identifyAndSyncUser(userID: string, orgID: string) {
          await statsigClient.updateUserAsync(createStatsigUser(userID, orgID));
        },
        track(event: string, properties?: Record<string, string>) {
          const instance = get().instance;

          const value = properties?.value;

          instance.logEvent(event, value, { ...properties });
        },
        getFeatureFlag(name: FeatureFlagName) {
          return get().instance.getFeatureGate(name).value;
        },
      };
    })
  );
}

type StatsigStore = ReturnType<ReturnType<typeof createStatsigStore>["getState"]>;

export const {
  getStore: getStatsigStore,
  getStoreAsync: getStatsigStoreAsync,
  getStoreApi: getStatsigStoreApi,
} = createStoreGetters<StatsigStore>("statsig");
